export default "__VITE_ASSET__17301ffa__"